import { render, staticRenderFns } from "./AddQuestionByProductGroupModal.vue?vue&type=template&id=10c5ff97&scoped=true&"
import script from "./AddQuestionByProductGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddQuestionByProductGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionByProductGroupModal.vue?vue&type=style&index=0&id=10c5ff97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5ff97",
  null
  
)

export default component.exports